<template>
  <RotatingCarousel
    :uid="uid"
    :slides="slides"
    :autoplay="autoplay"
    :bgImgUrl="bgImgUrl"
  />
</template>

<script>
import RotatingCarousel from "../../components/RotatingCarousel/RotatingCarousel.vue";

export default {
  name: "app",
  components: {
    RotatingCarousel
  },
  data() {
    return {
      uid: this.$options._parentVnode.data.props.uid,
      slides: JSON.parse(this.$options._parentVnode.data.props.slides),
      autoplay: this.$options._parentVnode.data.props.autoplay,
      bgImgUrl: this.$options._parentVnode.data.props.bgImgUrl
    };
  }
};
</script>
